/** Daywia design tokens as Tailwind class groups — matches DaywiaColorRoles.kt */

export const tw = {
  canvas: "bg-canvas text-ink dark:bg-dark-canvas dark:text-dark-ink",
  surface: "bg-surface dark:bg-dark-surface",
  chrome: "bg-surface dark:bg-dark-surface",
  section: "bg-soft dark:bg-dark-section",
  card: "rounded-2xl border border-border bg-card dark:border-dark-border dark:bg-dark-card",
  cardFlush:
    "border-b border-feed-divider bg-card dark:border-dark-feed-divider dark:bg-dark-card",
  soft: "bg-soft dark:bg-dark-surface-elevated",
  muted: "text-ink-muted dark:text-dark-muted",
  heading: "font-bold text-ink dark:text-dark-ink",
  link: "font-medium text-primary hover:underline dark:text-primary-dark",
  linkSemibold: "font-semibold text-primary dark:text-primary-dark",
  input:
    "w-full rounded-xl border border-border bg-surface px-3.5 py-2.5 text-sm text-ink outline-none transition placeholder:text-ink-muted focus:border-primary focus:ring-2 focus:ring-primary/20 dark:border-dark-border dark:bg-dark-surface dark:text-dark-ink dark:placeholder:text-dark-muted dark:focus:border-primary-dark",
  textarea:
    "w-full resize-none rounded-xl border border-border bg-surface px-4 py-3 text-sm outline-none focus:border-primary dark:border-dark-border dark:bg-dark-surface",
  listPanel:
    "overflow-hidden rounded-2xl border border-border bg-card dark:border-dark-border dark:bg-dark-card",
  listDivide: "divide-y divide-border dark:divide-dark-border",
  rowHover: "transition hover:bg-black/[0.03] dark:hover:bg-white/[0.04]",
  spinner:
    "h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent dark:border-primary-dark",
  iconBtn:
    "rounded-xl p-2.5 text-ink-muted transition hover:bg-black/5 dark:text-dark-muted dark:hover:bg-white/10",
  secondaryBtn:
    "inline-flex items-center justify-center gap-2 rounded-xl border border-border bg-soft px-3 py-2 text-sm font-semibold text-ink transition hover:bg-black/5 dark:border-dark-border dark:bg-dark-surface-elevated dark:text-dark-ink dark:hover:bg-white/5",
  error: "text-sm text-red-600 dark:text-red-400",
  errorBox:
    "rounded-xl border border-red-500/30 bg-red-500/10 px-3 py-3 text-sm text-red-700 dark:text-red-300",
} as const;
